import { ICompTrendsReportResponse, ISelectedShops } from '../../interfaces/comp-trends-report.interface'

export interface CompTrendsReportStateModel {
  trends: ICompTrendsReportResponse
  selectedShops: ISelectedShops
}
